import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {AnalyticsDashboardActions} from 'insights/analytics-dashboards/AnalyticsDashboardActions';
import {GraphQLAnalyticsDashboardSpec} from 'insights/analytics-dashboards/data/__generated/GraphQLAnalyticsDashboardSpec';
import * as MakeSpecRequest from 'insights/analytics-dashboards/data/MakeSpecRequest';
import runConfirmDeleteModal from 'ui-library/modals/runConfirmDeleteModal';
import {withLoadingScreen} from 'util/Promises';

export type Actions = Pick<AnalyticsDashboardActions, 'updateAnalyticsDashboard'> & {
  openDashboardEditor: () => void;
};

/**
 * Confirm and delete block from dashboard, with 'Deleting block...' loading screen
 */
export default async function deleteAnalyticsQueryFromDashboard(
  analyticsDashboard: GraphQLAnalyticsDashboardSpec,
  analyticsQueryId: string,
  actions: Actions
): Promise<void> {
  if (await runConfirmDeleteModal({typeName: 'block'})) {
    actions.openDashboardEditor();
    const newDashboard = await withLoadingScreen(
      actions.updateAnalyticsDashboard(
        analyticsDashboard.id,
        MakeSpecRequest.onDeleteAnalyticsQuery(analyticsDashboard, analyticsQueryId)
      ),
      'Deleting block...'
    );
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.DELETED_BLOCK, {
      num_blocks: newDashboard.analyticsQueries.length,
    });
  }
}
